import snsYoutubeIcon from '../../assets/images/sns/sns-youtube.png';
import snsInstaIcon from '../../assets/images/sns/sns-insta.png';
import snsTiktokIcon from '../../assets/images/sns/sns-tictok.png';
import snsXIcon from '../../assets/images/sns/sns-x.png';

const SNS_ITEMS = [
  {
    id: 'youtube',
    label: 'Youtube',
    icon: snsYoutubeIcon,
    href: 'https://youtube.com/@yaong_official?si=r4OsNtN-Bm6vNY9Z',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    icon: snsInstaIcon,
    href: 'https://www.instagram.com/yaong_official/',
  },
  {
    id: 'tiktok',
    label: 'Tiktok',
    icon: snsTiktokIcon,
    href: 'https://www.tiktok.com/@yaongofficial',
  },
  {
    id: 'x',
    label: 'X',
    icon: snsXIcon,
    href: 'https://x.com/yaong_official',
  },
];

async function openExternal(url) {
  if (!url) return;

  if (!window.flutter_inappwebview?.callHandler) {
    window.open(url, '_blank');
    return;
  }

  try {
    const result = await window.flutter_inappwebview.callHandler('open_external', url);
    if (!result?.opened) window.open(url, '_blank');
  } catch (e) {
    // 구버전 앱: 핸들러 없음
    window.open(url, '_blank');
  }
}

function PlaygroundSnsCardRow() {
  return (
    <div className="flex w-full items-start justify-around px-6 py-6">
      {SNS_ITEMS.map((item) => (
        <button
          key={item.id}
          type="button"
          className="flex flex-col items-center justify-start border-none bg-transparent p-0"
          onClick={() => openExternal(item.href)}
          aria-label={item.label}
        >
          <img
            src={item.icon}
            alt={item.label}
            className="h-[74px] w-[55px] object-contain"
            draggable={false}
          />
        </button>
      ))}
    </div>
  );
}

export default PlaygroundSnsCardRow;
